// extracted by mini-css-extract-plugin
export default {"month-block":"LW8eY","month-block__list":"oNJHE","month-block__month":"jgUE8","month-block__cell":"csr4T"};